import React, { useEffect } from 'react';
import Tiptap from 'adapter/in/common/components/Text/Tiptap/Tiptap';
import { Loading } from '@dexma/ui-components';
import RichTextData from 'domain/entity/widgets/RichTextData';
import { TiptapEditorExtensions, dispatchTextBlockData } from 'adapter/in/reports/contexts/TextBlockContext';
import { useEditor } from '@tiptap/react';
import styled from 'styled-components';
import { useLayoutsView } from 'adapter/in/common/context/Layouts/LayoutsContext';

type WidgetTextBlockProps = { textBlockId: string; data: RichTextData; isLoading: boolean; dashboardId?: string; editable?: boolean };

const TiptapWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
`;

const TextBlockWidget = ({ textBlockId, data, isLoading, dashboardId, editable }: WidgetTextBlockProps) => {
    const { addEditor } = dispatchTextBlockData();
    const { editLayoutMode } = useLayoutsView();

    const editor = useEditor({
        extensions: TiptapEditorExtensions,
        editable: editable && !editLayoutMode,
        content: data.text,
    });

    useEffect(() => {
        if (editor) {
            editor.setOptions({ editable: editable && !editLayoutMode });
        }
    }, [editor, editLayoutMode]);

    useEffect(() => {
        if (editor) addEditor({ textBlockId, editor });
    }, [editor, textBlockId, addEditor]);

    return (
        <TiptapWrapper>
            {isLoading || !editor ? (
                <Loading isLoading size={50} />
            ) : (
                <Tiptap dashboardId={dashboardId} editor={editor} textBlockId={textBlockId} content={data.text} />
            )}
        </TiptapWrapper>
    );
};

export default TextBlockWidget;
